import ApiService from "@/api.service";
import API from "@/API";
//banner
export const GET_LIST_BANNER = "listBanners";
export const GET_DETAIL_BANNER = "detailBanner";
export const SAVE_BANNER = "saveBanner";
export const UPDATE_BANNER = "updateBanner";
export const DELETE_BANNER = "deleteBanner";
export const UPLOAD_BANNER_IMAGE = "uploadBanner";
export const CHANGE_ACTIVE_BANNER = "changeActiveBanner";

export const SET_LIST_BANNER = "setListBanner";
export const SET_DETAIL_BANNER = "setDetailBanner";

//product category
export const GET_LIST_PRODUCT_CATEGORY = "listProductCategory";
export const GET_DETAIL_PRODUCT_CATEGORY = "detailProductCategory";
export const DELETE_PRODUCT_CATEGORY = "deleteProductCategory";
export const SAVE_PRODUCT_CATEGORY = "saveProductCategory";
export const UPDATE_PRODUCT_CATEGORY = "updateProductCategory";

export const SET_LIST_PRODUCT_CATEGORY = "setListProductCategory";
export const SET_DETAIL_PRODUCT_CATEGORY = "setDetailProductCategory";

//post
export const GET_POST_CONFIGS = 'getPostConfig';
export const UPDATE_POST_CONFIGS = 'updatePostConfig';

export const SET_POST_CONFIGS = 'setPostConfig';

export const UPLOAD_IMAGE = "uploadImageConfig";

// new post sidebar
export const GET_NEW_POST_CONFIGS_SIDEBAR = 'getNewPostConfigSidebar';
export const SET_NEW_POST_CONFIGS_SIDEBAR  = 'setNewPostConfigSidebar';
export const UPDATE_NEW_POST_CONFIGS_SIDEBAR  = 'updateNewPostConfigSidebar';

// config blanco
export const GET_LIST_CONFIG_BLANCO = 'getListConfigBlanco';
export const SET_LIST_CONFIG_BLANCO = 'setListConfigBlanco';
export const UPDATE_LIST_CONFIG_BLANCO = 'updateListConfigBlanco';
export const UPLOAD_BLANCO_IMAGE = "uploadBlanco";

// config bosch
export const GET_LIST_CONFIG_BOSCH = 'getListConfigBosch';
export const SET_LIST_CONFIG_BOSCH = 'setListConfigBosch';
export const UPDATE_LIST_CONFIG_BOSCH = 'updateListConfigBosch';

// config blum
export const GET_LIST_CONFIG_BLUM = 'getListConfigBlum';
export const SET_LIST_CONFIG_BLUM = 'setListConfigBlum';
export const UPDATE_LIST_CONFIG_BLUM = 'updateListConfigBlum';

// config blum
export const GET_LIST_CONFIG_WMF = 'getListConfigWmf';
export const SET_LIST_CONFIG_WMF = 'setListConfigWmf';
export const UPDATE_LIST_CONFIG_WMF = 'updateListConfigWmf';
export const UPLOAD_WMF_IMAGE = "uploadWmf";

// config finish
export const GET_LIST_CONFIG_FINISH = 'getListConfigFinish';
export const SET_LIST_CONFIG_FINISH = 'setListConfigFinish';
export const UPDATE_LIST_CONFIG_FINISH = 'updateListConfigFinish';

// config advise
export const GET_LIST_CONFIG_ADVISE = 'getListConfigAdvise';
export const SET_LIST_CONFIG_ADVISE = 'setListConfigAdvise';
export const UPDATE_LIST_CONFIG_ADVISE = 'updateListConfigAdvise';
export const UPLOAD_ADVISE_IMAGE = "uploadAdvise";

// config renew
export const GET_LIST_CONFIG_RENEW = 'GET_LIST_CONFIG_RENEW';
export const SET_LIST_CONFIG_RENEW = 'SET_LIST_CONFIG_RENEW';
export const UPDATE_LIST_CONFIG_RENEW = 'UPDATE_LIST_CONFIG_RENEW';
export const UPLOAD_RENEW_IMAGE = "UPLOAD_RENEW_IMAGE";

//config about
export const GET_CONFIG_ABOUT = 'getConfigAbout';
export const SET_CONFIG_ABOUT = 'setConfigAbout';
export const UPDATE_CONFIG_ABOUT = 'updateConfigAbout';

//config menu left
export const GET_CONFIG_MENU_LEFT = 'getConfigMenuLeft';
export const GET_DETAIL_CONFIG_MENU_LEFT = "getdetailConfigMenuLeft";
export const UPDATE_CONFIG_MENU_LEFT = 'updateConfigMenuLeft';
export const SAVE_CONFIG_MENU_LEFT = 'saveConfigMenuLeft';
export const DELETE_CONFIG_MENU_LEFT = "deleteConfigMenuLeft";
export const SET_CONFIG_MENU_LEFT = 'setConfigMenuLeft';
export const SET_DETAIL_CONFIG_MENU_LEFT = 'setDetailConfigMenuLeft';
export const UPDATE_CONFIG_MENU_LEFT_HIDDEN = "updateHiddenMenu";

// config accessory
export const GET_CONFIG_ACCESSORY = 'getConfigAccessory';
export const SET_CONFIG_ACCESSORY = 'setListConfigAccessory';
export const UPDATE_CONFIG_ACCESSORY = 'updateListConfigAccessory';

// config whybuy
export const GET_CONFIG_WHYBUY = 'getConfigWhyBuy';
export const SET_CONFIG_WHYBUY = 'setListConfigWhyBuy';
export const UPDATE_CONFIG_WHYBUY = 'updateListConfigWhyBuy';

// config showroom
export const GET_CONFIG_SHOWROOM = 'getConfigShowroom';
export const SET_CONFIG_SHOWROOM = 'setListConfigShowroom';
export const UPDATE_CONFIG_SHOWROOM = 'updateListConfigShowroom';

// config showroom link
export const GET_CONFIG_SHOWROOM_LINK = 'getConfigShowroomLink';
export const SET_CONFIG_SHOWROOM_LINK = 'setListConfigShowroomLink';
export const UPDATE_CONFIG_SHOWROOM_LINK = 'updateListConfigShowroomLink';

// config footer
export const GET_CONFIG_FOOTER = 'getConfigFooter';
export const SET_CONFIG_FOOTER = 'setListConfigFooter';
export const UPDATE_CONFIG_FOOTER = 'updateListConfigFooter';

const state = {
    //banner
    banners: [],
    banner: {},
    //product category
    product_categories: [],
    product_category: {},
    //post
    post_config: {},
    //post sidebar
    post_config_sidebar: {},
    config_bosch : {},
    config_wmf : {},
    config_blum : {},
    config_finish : {},
    config_blanco : {},
    config_advise: {},
    config_renew: {},
    config_about: {},
    config_accessory: {},
    config_whybuy: {},
    config_showroom: {
        banner:[],
        description: null
    },
    config_footer: {
        post_info: [],
        post_policy: [],
        contact_sell: [],
        contact_warranty: [],
        contact_complain: [],
        contact_wholesale: [],
        contact_project_sale: [],
        address: []
    },
    //menu left
    config_menu_left: [],
    detail_menu_left: {},
    config_showroom_link: {}
};

const getters = {
    config_showroom_link(state) {
        return state.config_showroom_link;
    },
    //banner
    banners(state) {
        return state.banners;
    },
    banner(state) {
        return state.banner;
    },
    //product category
    product_categories(state) {
        return state.product_categories;
    },
    product_category(state) {
        return state.product_category;
    },
    //post_config
    post_config(state) {
        return state.post_config;
    },
    post_config_sidebar(state) {
        return state.post_config_sidebar;
    },
    config_blanco(state) {
        return state.config_blanco;
    },
    config_bosch(state) {
        return state.config_bosch;
    },
    config_blum(state) {
        return state.config_blum;
    },
    config_wmf(state) {
        return state.config_wmf;
    },
    config_finish(state) {
        return state.config_finish;
    },
    config_advise(state) {
        return state.config_advise;
    },
    config_renew(state) {
        return state.config_renew;
    },
    config_about(state) {
        return state.config_about;
    },
    config_accessory(state) {
        return state.config_accessory;
    },
    detail_menu_left(state) {
        return state.detail_menu_left;
    },
    config_menu_left(state) {
        return state.config_menu_left;
    },
    config_whybuy(state) {
        return state.config_whybuy;
    },
    config_showroom(state) {
        return state.config_showroom;
    },
    config_footer(state) {
        return state.config_footer;
    },
};

const actions = {
    [GET_CONFIG_SHOWROOM_LINK](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_CONFIG_SHOWROOM_LINK).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_CONFIG_SHOWROOM_LINK, data.data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_CONFIG_SHOWROOM_LINK](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${API.UPDATE_CONFIG_SHOWROOM_LINK}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //banner
    [GET_LIST_BANNER](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_BANNER).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_BANNER, data);
                }
                resolve(data);
            });
        });
    },
    [GET_NEW_POST_CONFIGS_SIDEBAR](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_NEW_POST_CONFIGS_SIDEBAR).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_NEW_POST_CONFIGS_SIDEBAR, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_BANNER](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_BANNER}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_BANNER, data.data);
                }
                resolve(data);
            });
        });
    },
    [UPLOAD_BANNER_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_BANNER_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [SAVE_BANNER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_BANNER}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_BANNER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_BANNER}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_NEW_POST_CONFIGS_SIDEBAR](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_NEW_POST_CONFIGS_SIDEBAR}`, 'sidebar', payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_BANNER](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_BANNER}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [CHANGE_ACTIVE_BANNER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${API.CHANGE_ACTIVE_BANNER}/${payload.id}/active`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //product category
    [GET_LIST_PRODUCT_CATEGORY](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_PRODUCT_CATEGORY).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_PRODUCT_CATEGORY, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_PRODUCT_CATEGORY](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_PRODUCT_CATEGORY}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_PRODUCT_CATEGORY, data.data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_PRODUCT_CATEGORY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_PRODUCT_CATEGORY}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_PRODUCT_CATEGORY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_PRODUCT_CATEGORY}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_PRODUCT_CATEGORY](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_PRODUCT_CATEGORY}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //post
    [GET_POST_CONFIGS](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_POST_CONFIGS).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_POST_CONFIGS, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_POST_CONFIGS](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.put(API.UPDATE_POST_CONFIGS, payload).then(({ data }) => {
                if (data) {
                    context.commit(SET_POST_CONFIGS, data);
                }
                resolve(data);
            }).catch((err) => {
                reject(err);
            });
        });
    },
    // config blanco 
    [GET_LIST_CONFIG_BLANCO](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_CONFIG_BLANCO).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_CONFIG_BLANCO, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_LIST_CONFIG_BLANCO](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.update(API.UPDATE_LIST_CONFIG_BLANCO, 'content',payload).then((data) => {
                resolve(data)
            })
            .catch((err) => {
                reject(err);
            });
        });
    },
    [UPLOAD_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // config bosch
    [GET_LIST_CONFIG_BOSCH](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_CONFIG_BOSCH).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_CONFIG_BOSCH, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_LIST_CONFIG_BOSCH](context, payload) {
        return new Promise(resolve => {
            ApiService.update(API.UPDATE_LIST_CONFIG_BOSCH, 'content', payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_CONFIG_BOSCH, data);
                }
                resolve(data);
            });
        });
    },
    // config blum
    [GET_LIST_CONFIG_BLUM](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_CONFIG_BLUM).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_CONFIG_BLUM, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_LIST_CONFIG_BLUM](context, payload) {
        return new Promise(resolve => {
            ApiService.update(API.UPDATE_LIST_CONFIG_BLUM, 'content', payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_CONFIG_BLUM, data);
                }
                resolve(data);
            });
        });
    },
    // config wmf
    [GET_LIST_CONFIG_WMF](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_CONFIG_WMF).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_CONFIG_WMF, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_LIST_CONFIG_WMF](context, payload) {
        return new Promise(resolve => {
            ApiService.update(API.UPDATE_LIST_CONFIG_WMF, 'content', payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_CONFIG_WMF, data);
                }
                resolve(data);
            });
        });
    },
    [UPLOAD_WMF_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_WMF_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // config finish
    [GET_LIST_CONFIG_FINISH](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_CONFIG_FINISH).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_CONFIG_FINISH, data);
                    console.log("data finish", data)
                }
                resolve(data);
            });
        });
    },
    [UPDATE_LIST_CONFIG_FINISH](context, payload) {
        return new Promise(resolve => {
            ApiService.update(API.UPDATE_LIST_CONFIG_FINISH, 'content', payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_CONFIG_FINISH, data);
                }
                resolve(data);
            });
        });
    },
    // config advise
    [GET_LIST_CONFIG_ADVISE](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_CONFIG_ADVISE).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_CONFIG_ADVISE, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_LIST_CONFIG_ADVISE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(API.UPDATE_LIST_CONFIG_ADVISE, 'content',payload).then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
        });
    },
    [UPLOAD_ADVISE_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_ADVISE_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // config renew
    [GET_LIST_CONFIG_RENEW](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_CONFIG_RENEW).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_CONFIG_RENEW, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_LIST_CONFIG_RENEW](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(API.UPDATE_LIST_CONFIG_RENEW, 'content',payload).then(({ data }) => {
                resolve(data);
            })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPLOAD_RENEW_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_RENEW_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // config about
    [GET_CONFIG_ABOUT](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_CONFIG_ABOUT).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_CONFIG_ABOUT, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_CONFIG_ABOUT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(API.UPDATE_CONFIG_ABOUT, 'content', payload).then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
        });
    },
    // config menu left
    [GET_CONFIG_MENU_LEFT](context, exceptId = null) {
        return new Promise(resolve => {
            ApiService.query(API.CONFIG_MENU_LEFT, {exceptId: exceptId}).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_CONFIG_MENU_LEFT, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_CONFIG_MENU_LEFT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(API.CONFIG_MENU_LEFT, payload).then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
        });
    },
    [UPDATE_CONFIG_MENU_LEFT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(API.CONFIG_MENU_LEFT, payload.id, payload).then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
        });
    },
    [GET_DETAIL_CONFIG_MENU_LEFT](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.CONFIG_MENU_LEFT}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_CONFIG_MENU_LEFT, data.data);
                }
                resolve(data);
            });
        });
    },
    [DELETE_CONFIG_MENU_LEFT](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.CONFIG_MENU_LEFT}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_CONFIG_MENU_LEFT_HIDDEN](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${API.UPDATE_CONFIG_MENU_LEFT_HIDDEN}/${payload.id}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // config accessory
    [GET_CONFIG_ACCESSORY](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_CONFIG_ACCESSORY).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_CONFIG_ACCESSORY, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_CONFIG_ACCESSORY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(API.UPDATE_CONFIG_ACCESSORY, 'content', payload).then((data) => {
                resolve(data)
            })
            .catch((err) => {
                console.log(err)
                reject(err);
            });
        });
    },
    // whybuy
    [GET_CONFIG_WHYBUY](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_CONFIG_WHYBUY).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_CONFIG_WHYBUY, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_CONFIG_WHYBUY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(API.UPDATE_CONFIG_WHYBUY, 'content', payload).then((data) => {
                resolve(data)
            })
            .catch((err) => {
                console.log(err)
                reject(err);
            });
        });
    },
    // showroom
    [GET_CONFIG_SHOWROOM](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_CONFIG_SHOWROOM).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_CONFIG_SHOWROOM, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_CONFIG_SHOWROOM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(API.UPDATE_CONFIG_SHOWROOM, 'content', payload).then((data) => {
                resolve(data)
            })
            .catch((err) => {
                console.log(err)
                reject(err);
            });
        });
    },
    // footer
    [GET_CONFIG_FOOTER](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_CONFIG_FOOTER).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_CONFIG_FOOTER, data);
                }
                resolve(data);
            });
        });
    },
    [UPDATE_CONFIG_FOOTER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(API.UPDATE_CONFIG_FOOTER, 'content', payload).then((data) => {
                resolve(data)
            })
            .catch((err) => {
                console.log(err)
                reject(err);
            });
        });
    },
    [UPLOAD_BLANCO_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_CONFIG_SHOWROOM_LINK](state, data) {
        state.config_showroom_link = data;
    },
    //banner
    [SET_LIST_BANNER](state, data) {
        state.banners = data.data;
    },
    [SET_DETAIL_BANNER](state, data) {
        state.banner = data;
    },
    //product category
    [SET_LIST_PRODUCT_CATEGORY](state, data) {
        state.product_categories = data.data;
    },
    [SET_DETAIL_PRODUCT_CATEGORY](state, data) {
        state.product_category = data;
    },
    //post
    [SET_POST_CONFIGS](state, data) {
        state.post_config = data.data;
    },
    [SET_NEW_POST_CONFIGS_SIDEBAR](state, data) {
        state.post_config_sidebar = data.data;
    },
    // blanco
    [SET_LIST_CONFIG_BLANCO](state, data) {
        state.config_blanco = data.data;
    },
        // bosch
    [SET_LIST_CONFIG_BOSCH](state, data) {
        state.config_bosch = data.data;
    },      
     // blum
    [SET_LIST_CONFIG_BLUM](state, data) {
        state.config_blum = data.data;
    },
    // wmf
    [SET_LIST_CONFIG_WMF](state, data) {
        state.config_wmf = data.data;
    },
    // finsh
    [SET_LIST_CONFIG_FINISH](state, data) {
        state.config_finish = data.data;
    },
    //advise
    [SET_LIST_CONFIG_ADVISE](state, data) {
        state.config_advise = data.data;
    },
    //renew
    [SET_LIST_CONFIG_RENEW](state, data) {
        state.config_renew = data.data;
    },
    //about
    [SET_CONFIG_ABOUT](state, data) {
        state.config_about = data.data;
    },
    //menu left
    [SET_CONFIG_ABOUT](state, data) {
        state.config_about = data.data;
    },
    [SET_CONFIG_MENU_LEFT](state, data) {
        state.config_menu_left = data.data;
    },
    [SET_DETAIL_CONFIG_MENU_LEFT](state, data) {
        state.detail_menu_left = data;
    },
    // accessory
    [SET_CONFIG_ACCESSORY](state, data) {
       state.config_accessory = data.data;
    },
    // whybuy
    [SET_CONFIG_WHYBUY](state, data) {
       state.config_whybuy = data.data;
    },
    // showroom
    [SET_CONFIG_SHOWROOM](state, data) {
        if(!Array.isArray(data.data)){
            state.config_showroom = data.data;
        }
    },
    // footer
    [SET_CONFIG_FOOTER](state, data) {
        if(!Array.isArray(data.data)){
            state.config_footer = data.data;
        }
       
    },
    
};

export default {
    state,
    actions,
    mutations,
    getters
};